import TomSelect from "tom-select";

type EnhancedSelectElement = HTMLSelectElement & { tomselect?: TomSelect };

/**
 * Progressively enhance native <select> fields rendered by the form flow
 * (see node2html() in class-wp-form-flow-rest.php) with a searchable
 * Tom Select control. Safe to call repeatedly: already-enhanced elements
 * (tracked via the `tomselect` instance Tom Select attaches to the
 * original element) are skipped.
 */
export function initSearchableSelects(root: ParentNode): void {
  const selects: EnhancedSelectElement[] =
    root instanceof HTMLSelectElement
      ? [root]
      : Array.from(root.querySelectorAll<HTMLSelectElement>("select"));

  for (const select of selects) {
    if (select.tomselect) {
      continue;
    }

    new TomSelect(select, {
      maxOptions: null,
      controlInput: '<input type="text" autocomplete="off" />',
    });
  }
}
